import React from 'react';

const Messages = () => {
  return (
    <div>
      <h1>Messages & Issues</h1>

      <section>
        <h3>Recent Messages</h3>
        <ul>
          <li><strong>Landlord:</strong> Don’t forget to submit meter readings - <em>Oct 5</em></li>
          <li><strong>You:</strong> Thanks, will do it by tonight - <em>Oct 5</em></li>
        </ul>
      </section>

      <section>
        <h3>Reported Issues</h3>
        <ul>
          <li>Broken shower knob - <em>Reported Oct 3</em> - Status: In progress</li>
        </ul>
      </section>
    </div>
  );
};

export default Messages;
